var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarninigWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37622 27.1217H27.6351C29.4013 27.1217 30.5384 25.2587 29.74 23.6861L17.1106 1.30631C16.2393 -0.435437 13.7476 -0.435437 12.8766 1.30631L0.24712 23.6861C-0.527098 25.2587 0.610035 27.1217 2.37622 27.1217ZM16.9898 21.9199C16.9898 23.0812 16.143 23.9764 14.9333 23.9764C13.7236 23.9764 12.8768 23.0812 12.8768 21.9199V21.8715C12.8768 20.7102 13.7236 19.815 14.9333 19.815C16.143 19.815 16.9898 20.7102 16.9898 21.8715V21.9199ZM13.8201 6.79843H16.1914C16.8444 6.79843 17.2318 7.3549 17.1592 8.05653L16.1186 17.1536C16.046 17.8068 15.6105 18.2181 15.0057 18.2181C14.4008 18.2181 13.9653 17.8068 13.8927 17.1536L12.8521 8.05653C12.7798 7.3549 13.1671 6.79843 13.8201 6.79843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarninigWhite);
export default __webpack_public_path__ + "static/media/warninig_white.645a3f0bb5bbbffb81003f54b9fc2d9b.svg";
export { ForwardRef as ReactComponent };